<template>
    <admin-dashboard-layout>
        <v-data-table
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="documents_types"
            :items-per-page="30"
            class="elevation-1"
            @click:row="handleClickRow"
        >
            <template v-slot:item.created_at="{ item }">
                {{ item.created_at ? moment(item.created_at).format('LLL') : '' }}
            </template>
        </v-data-table>
    </admin-dashboard-layout>
</template>

<script>
    import AdminDashboardLayout from "../../../layouts/AdminDashboardLayout";
    import DocumentsType from "../../../models/admin/DocumentsType";

    /* eslint-disable */
    export default {
        name: "documents-types-index",
        components: {
            AdminDashboardLayout,
        },
        data: function () {
            return {
                loading: false,
                documents_types: [],
                headers: [
                    {
                        text: '# ID',
                        align: 'start',
                        sortable: false,
                        value: 'id',
                    },
                    { text: 'Code', value: 'code' },
                    { text: 'Name', value: 'name' },
                    { text: 'Active', value: 'is_active' },
                    { text: 'Created at', value: 'created_at' },
                ],
            }
        },
        methods: {
            handleClickRow(docyments_type) {
                this.$router.push({name: 'admin.documents_types.show', params: {id: docyments_type.id}})
            }
        },
        async mounted() {
            this.loading = true
            this.documents_types = await DocumentsType.get()
            this.loading = false
        },
    }
</script>

<style scoped>

</style>
